import { ExitToApp, LockOpen, Person } from '@mui/icons-material';
import { Routing } from '@fabiulous/routing/dist/types';

import { Dictionary } from '@shared/dictionary';


export const routes = {
  home: '/',
  welcome: '/welcome',
  auth: {
    path: '/auth',
    routes: {
      impersonateUser: '/impersonate',
      login: '/login',
      resetPasswordConfirm: '/reset-password-confirm',
      resetPassword: '/reset-password',
      signup: '/signup',
    },
  },
  team: '/team',
  objectives: {
    path: '/objectives',
    routes: {
      current: '/current',
      history: '/history',
    },
  },
  values: {
    path: '/values',
    routes: {
      current: '/current',
      history: '/history',
    },
  },
  skillTracker: '/skill-tracker',
  stories: {
    path: '/stories',
    routes: {
      create: '/create',
      edit: (storyId: string | number = ':storyId') => `/edit/${storyId}`,
      view: (storyId: string | number = ':storyId') => `/view/${storyId}`,
    },
  },
  meetings: {
    path: '/meetings',
    routes: {
      list: {
        path: '/list',
        routes: {
          upcoming: '/upcoming',
          past: '/past',
          all: '/all',
        },
      },
      create: '/create',
      edit: (meetingId: string | number = ':meetingId') => `/edit/${meetingId}`,
      view: (meetingId: string | number = ':meetingId') => `/view/${meetingId}`,
    },
  },
  onboarding: {
    path: '/onboarding',
    routes: {
      objectives: '/objectives',
      values: '/values',
      story: '/story',
    },
  },
  users: {
    path: '/users',
    routes: {
      create: '/create',
      myAccount: '/my-account',
      edit: (userId: string | number = ':userId') => `/edit/${userId}`,
      invite: (token: string = ':token') => `/invitation/${token}`,
    },
  },
  programs: {
    path: '/programs',
    routes: {
      link: (slug: string = ':slug') => `/${slug}`,
      enroll: (programId: string | number = ':programId') => `/enroll/${programId}`,
      journey: {
        path: '/journey',
        routes: {
          welcome: (enrollmentId: string | number = ':enrollmentId') => `/${enrollmentId}`,
          step: (enrollmentId: string | number = ':enrollmentId') => `/${enrollmentId}/step`,
          complete: (enrollmentId: string | number = ':enrollmentId') => `/${enrollmentId}/complete`,
          review: (enrollmentId: string | number = ':enrollmentId') => `/${enrollmentId}/review`,
        },
      },
    },
  },
  companies: {
    path: '/companies',
    routes: {
      create: '/create',
      edit: (companyId: string | number = ':companyId') => `/edit/${companyId}`,
    },
  },
};

export const navigation = (router: Routing.RecursiveRoutes<typeof routes>, dictionary: Dictionary): CVT.Navigation.Config => ({
  userMenu: [{
    icon: <Person/>,
    text: dictionary.menu.users.myAccount,
    route: router.users.myAccount.path,
    requiresAuth: true,
  }, {
    icon: <LockOpen/>,
    text: dictionary.menu.auth.login,
    route: router.auth.login.path,
    requiresAuth: false,
  }, {
    icon: <ExitToApp/>,
    text: dictionary.menu.auth.signUp,
    route: router.auth.signup.path,
    requiresAuth: false,
  }],
  sidebar: [{
    text: dictionary.header.objectives,
    route: router.objectives.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.values,
    route: router.values.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.skillTracker,
    route: router.skillTracker.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.stories,
    route: router.stories.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.meetings,
    route: router.meetings.list.path,
    requiresAuth: true,
  }, {
    divider: true,
  }],
  header: [{
    text: dictionary.header.objectives,
    route: router.objectives.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.values,
    route: router.values.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.skillTracker,
    route: router.skillTracker.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.stories,
    route: router.stories.path,
    requiresAuth: true,
  }, {
    text: dictionary.header.meetings,
    route: router.meetings.list.path,
    requiresAuth: true,
  }],
});
